import type { PaletteMode } from '../types';

interface ParsedMode {
    mode: PaletteMode;
    query: string;
}

/**
 * Convert a raw input string into a (mode, stripped query) pair.
 *
 *   "@ivan"   -> { mode: 'users',   query: 'ivan' }
 *   "#42"     -> { mode: 'threads', query: '42' }
 *   ">create" -> { mode: 'actions', query: 'create' }
 *   "ivan"    -> { mode: 'all',     query: 'ivan' }
 *
 * A bare prefix character with nothing after it still narrows the mode.
 */
export function parseMode(raw: string): ParsedMode {
    if (raw.length === 0) {
        return { mode: 'all', query: '' };
    }
    const head = raw[0];
    if (head === '@') return { mode: 'users', query: raw.slice(1) };
    if (head === '#') return { mode: 'threads', query: raw.slice(1) };
    if (head === '>') return { mode: 'actions', query: raw.slice(1) };
    return { mode: 'all', query: raw };
}
